import React, { memo, useState } from 'react';
import GuideHeader from './GuideHeader';
import GuideSidebar from './GuideSidebar';
import StepEditor from './StepEditor';
import StepProperties from './StepProperties';
import MediaModals from './MediaModals';
import GuidePreviewer from './GuidePreviewer';
import GuideAIChat from '../guide-chat/GuideAIChat';
import { useGuideBuilderGuide } from '../../contexts/GuideBuilderContext';

const GuideBuilderEditor: React.FC = memo(() => {
  const {
    guide,
    state: { isPreviewMode },
  } = useGuideBuilderGuide();
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <GuideHeader onOpenChat={() => setIsChatOpen(true)} />
      {isPreviewMode ? (
        <GuidePreviewer guide={guide} />
      ) : (
        <>
          <div className="flex flex-row h-[calc(100vh-80px)]">
            {/* Left Sidebar */}
            <div className="flex-2 overflow-y-auto border-r border-gray-200 min-w-[350px]">
              <GuideSidebar />
            </div>

            {/* Main Content */}
            <div className="flex-5 bg-content2 h-[calc(100vh-80px)] overflow-y-scroll">
              <StepEditor />
            </div>

            {/* Right Sidebar */}
            <div className="flex-2 border-l border-gray-200 min-w-[250px] h-[calc(100vh-80px)] overflow-y-scroll">
              <StepProperties />
            </div>
          </div>

          {/* Modals */}
          <MediaModals />

          {/* AI Chat */}
          <GuideAIChat isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
        </>
      )}
    </div>
  );
});

GuideBuilderEditor.displayName = 'GuideBuilderEditor';

export default GuideBuilderEditor;
